import React, { useState, useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import LoginIcon from './create_novel_illustration.svg'
import { FloatingInput } from '../../../../components/FormComponents'
import { get, post } from '../../../../lib/api'
import { menuItemObj } from '../../../../components/PrivatePage'
import { Text, Button } from '../../../../designSystem'
import { checkOverseasUser, handleEventLog, handlePageLoadEventLog, handleNotionOrExternalLink } from '../../../../lib/utils'
import { getImageUrl } from '../../../../lib/utils/convertCanvasToImage'
import VideoPlayer from '../../../../components/VideoPlayer'
import {
  isMobileOrTablet,
  getModuleOrTextAccordingToLocale,
} from '../../../Home/helpers'
import { AccountContext } from '../../../../providers/accountProvider'
import {
  Wrapper,
  ErrorMessage,
  Container,
  LeftDiv,
  MainDiv,
  RightDiv,
} from './styles'
import { useGetUsersData } from './helperHooks'
import { handleNewEventLog } from '../../../../lib/utils/events'
import useSubCreationTab from '../../../../lib/customHooks/useSubCreationTab'
import SubTabs from '../../../../components/SubTabs'

import Loader from '../../../../components/Loader'

const contestReferrer =
  window.location.href.includes('contest') ||
  localStorage.getItem('referrer')?.includes('contest')

export const uploadFile = (
  file,
  bookName,
  referrer,
  isUgcUser,
  isOnboardingRevampFlow,
  language,
) => {
  const fileNameSplit = file.name.split('.')
  const ext = fileNameSplit.length > 1 ? fileNameSplit.pop() : ''
  const params = {
    tags: 'image',
    image_extension: ext,
    title: bookName,
    is_novel: 1,
  }
  const getPreSignedUrl = '/upload/get_presigned_url'
  get(getPreSignedUrl, { params }).then((response) => {
    const imageUrl = response.result[0]
    const awsFields = imageUrl.fields
    const suffix = imageUrl.s3_unique_key
    const formData = new FormData()
    formData.append('key', awsFields.key)
    formData.append('AWSAccessKeyId', awsFields.AWSAccessKeyId)
    formData.append('x-amz-security-token', awsFields['x-amz-security-token'])
    formData.append('policy', awsFields.policy)
    formData.append('signature', awsFields.signature)
    formData.append('file', file)
    const prefix = imageUrl.url
    const cdn = 'https://djhonz7dexnot.cloudfront.net'
    post(prefix, {
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((response) => {
      const data = {
        book_title: bookName,
        image_url: `${cdn}/${suffix}`,
        view: 'writers',
      }
      if (isUgcUser) {
        data.language = language || 'english'
      }
      post(`/content_api/book.create_book?is_novel=${(isUgcUser || language === 'hindi') ? 2 : 1}`, {
        data: data,
      }).then((response) => {
        const { book_id, is_novel } = response.results
        if (contestReferrer) {
          const books = localStorage.getItem('contestBooks') || []
          const list = [...books, book_id]
          localStorage.setItem('contestBooks', JSON.stringify(list))
        }
        if (is_novel === 2) {
          const {
            image_url,
            created_by,
            description,
            description_en,
            editor_score,
            tags,
          } = response.results
          const showData = {
            created_by: created_by,
            uid: created_by,
            show_title: bookName,
            show_desc: description,
            show_desc_en: description_en,
            language: language ||  'english',
            editor_score: editor_score,
            is_disabled: 0,
            image_url: image_url,
            author_id: created_by,
            sort_order: 'asc',
            series: 1,
            data_source: 'writers',
            is_ugc: 1,
          }
          post(`/content_api/show.create?is_novel=0`, { data: showData }).then(
            (res) => {
              const { show_id } = res.result[0].show_info
              post(`/content_api/book.associate_book_and_show?is_novel=1`, {
                data: {
                  show_id,
                  book_id,
                  created_by,
                  tags,
                },
              }).then(() => {
                if (!isOnboardingRevampFlow)
                  window.location.assign(
                    `${menuItemObj.novels}/edit-novel-details/${book_id}?proceed_to_chapter=1`
                  )
                else
                  window.location.assign(
                    `${menuItemObj.novels}/add-chapter/${book_id}?proceed_to_details=1&novel_creation_flow=1`
                  )
              })
            }
          )
        } else {
          window.location.assign(
            `${menuItemObj.novels}/add-chapter/${book_id}?proceed_to_details=1&novel_creation_flow=1`
          )
        }

        // if(book_id) {
        //   if(isUgcUser){
        //     window.location.assign(`${menuItemObj.novels}/edit-novel-details/${book_id}?proceed_to_chapter=1`)
        //   }else{
        //     window.location.assign(`${menuItemObj.novels}/add-chapter/${book_id}?proceed_to_details=1&novel_creation_flow=1`)
        //   }
        // }
      })
    })
  })
}

const CreateNew = ({history, isHome, isSeries}) => {
  const { user, isUgcUser, isHindiUgcUser} = useContext(AccountContext)
  const [bookName, updateBookName] = useState('')
  const [isBookNameInvalid, setIsBookNameInvalid] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [isBookCreateProcessing, setIsBookCreateProcessing] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const queryString = window.location.search
  const params = new URLSearchParams(queryString)
  const referrer = params.get('referrer')
  const { userData, updateInviteCode } = useGetUsersData()
  const [inviteCode, setInviteCode] = useState('')
  const { tabSelected, handleTabClick } = useSubCreationTab(history)
  const showSeries = isUgcUser || tabSelected === 1

  const isUserFromIndia =
    !checkOverseasUser(user) && user?.languages !== 'english'
  useEffect(async () => {
    handleNewEventLog(
      'novels',
      isHome
        ? 'writer_home_create_new_novel_cta_viewed'
        : 'novels_new_novel_title_screen_viewed',
      {
        route: window.location.pathname + window.location.search,
        module_name: 'create_new_novel',
      },
      user
    )
    try {
      //Automating book create process for new users(from Pocket Novel App)
      const process = sessionStorage.getItem('process')
      const book_count = sessionStorage.getItem('book_count')
      if (process === 'create-new') {
        setIsLoading(true)
        handlePageLoadEventLog('create_new_novel')
        await handleBookCreate(`Untitled Book ${parseInt(book_count) + 1}`)
      }
    } catch (error) {
      console.log(error)
      setIsLoading(true)
    }
  }, [])

  const handleBookNameInputChange = (text) => {
    if (isBookNameInvalid) {
      setIsBookNameInvalid(false)
      setErrorMessage('')
    }
    updateBookName(text)
  }

  const checkTitleValidOrNot = () => {
    if (isBookCreateProcessing) return
    if (!bookName || bookName.trim().length === 0) {
      setIsBookNameInvalid(true)
      setErrorMessage('Enter title')
      return
    }
    if (bookName.trim().length > 70) {
      setIsBookNameInvalid(true)
      setErrorMessage("Title shouldn't be more than 70 characters")
      return
    }
    setIsBookNameInvalid(false)
    setIsBookCreateProcessing(true)
    if (inviteCode.length > 0) {
      updateInviteCode(inviteCode)
    }
    if (isUgcUser || isHindiUgcUser) {
      get(
        `/search/novel_search/similar_titles/?query=${bookName}&is_novel=1`
      ).then((res) => {
        if (res?.results?.length) {
          setIsBookCreateProcessing(false)
          setIsBookNameInvalid(true)
          setErrorMessage('Sorry, we have series with similar name')
        } else {
          handleBookCreate(bookName)
        }
      })
    } else {
      handleBookCreate(bookName)
    }
  }

  const handleBookCreate = async (paramBookName) => {
    handleNewEventLog(
      'novels',
      isHome
        ? 'writer_home_create_new_novel_cta_clicked'
        : 'novels_new_novel_title_created',
      {
        route: window.location.pathname + window.location.search,
        button: 'create_new_novel',
      },
      user
    )
    //adding a paramBookName to handle cases where we are passing bookName during function call
    handleEventLog('create_new_novel', 'button_click', {
      route: window.location.pathname + window.location.search,
      button: 'create_book',
    })
    const coverFile = await getImageUrl(paramBookName.trim(), user.fullname)
    uploadFile(coverFile, paramBookName, referrer, isUgcUser || tabSelected === 1, undefined, tabSelected === 1 ? 'hindi' : 'english')
  }

  let CreateCtaText = ''
  if (contestReferrer) {
    CreateCtaText =
      'Your Novel will be a part of Contest and also eligible for Writer Benefit program'
  } else {
    CreateCtaText = 'Your Novel will be a part of Writer Benefit program'
  }

  const tabFilterOnLanguageBasis = ['hindi', 'tamil', 'english'].includes(
    user.languages
  )

  if (!tabFilterOnLanguageBasis || !isUserFromIndia) {
    CreateCtaText = 'Start Your Journey'
  }

  return (
    <>
      {isHindiUgcUser && isHome && <SubTabs selectedIndex={tabSelected} handleTabClick={(index) => handleTabClick(index)}/>}
      <Wrapper isHome={isHome}>
        {isLoading ? (
          <Loader />
        ) : (
          <Container>
            <MainDiv isHome={isHome} isMobile={isMobileOrTablet()}>
              <LeftDiv
                isUgcUser={showSeries}
                userLanguages={user?.languages || ''}
              >
                {user?.languages === 'hindi' || showSeries ? (
                  <VideoPlayer
                    videoSrc={getModuleOrTextAccordingToLocale(
                      user,
                      'videoTutorialSrc',
                      isUgcUser, 
                      tabSelected === 1
                    )}
                    videoType="video/mp4"
                    isSeries={showSeries}
                  />
                ) : (
                  <div>
                    <img src={LoginIcon} alt="" />
                  </div>
                )}
              </LeftDiv>
              <RightDiv isHome={isHome}>
                <Text variant="titleMedium" mb={16}>
                  {getModuleOrTextAccordingToLocale(
                    user,
                    contestReferrer
                      ? 'createContestNewNovelHeading'
                      : 'createNewNovelHeading',
                    showSeries, 
                    tabSelected === 1
                  )}
                </Text>

                <Text variant="titleSecondary" fontWeight="r" mb={24}>
                  {showSeries ? 'Start Your Journey' : CreateCtaText}
                  {(isUgcUser|| tabSelected === 1)&& <span aria-label="Guide">📘
                        <span 
                            style={{ cursor: 'pointer', color: 'blue', textTransformation: 'underline'}}
                            onClick={() => handleNotionOrExternalLink(getModuleOrTextAccordingToLocale(user,'guideLink',undefined,tabSelected === 1) || 'https://pocketnovel.notion.site/35838ce4579843f196a99e92ed02c2e1?v=f4fe620088cd4b8cae9e2edfa630753c&pvs=4')}
                        >
                            Guide
                        </span>
                    </span>}
                </Text> 

                <FloatingInput
                  type="text"
                  name="book-name"
                  value={bookName}
                  label={getModuleOrTextAccordingToLocale(user, 'label', showSeries,tabSelected === 1)}
                  height="48px"
                  padding="4px 8px"
                  fontSize="12px"
                  onChange={(text) => handleBookNameInputChange(text)}
                />
                {isBookNameInvalid && <ErrorMessage>{errorMessage}</ErrorMessage>}

                {user?.location !== 'IN' &&
                  userData?.invite_code?.show_invite_code &&
                  !userData?.invite_code?.invite_code && (
                    <>
                      <Text variant="title" fontWeight="r" mb={4} mt={24}>
                        Have an invite code ?
                      </Text>
                      <Text variant="subtext" fontWeight="r" mb={16}>
                        If you were invited, please remember to fill in the
                        corresponding invitation code
                      </Text>
                      <FloatingInput
                        type="text"
                        name="invite_code"
                        value={inviteCode}
                        label="Invite code"
                        height="48px"
                        padding="4px 8px"
                        fontSize="12px"
                        onChange={(text) => setInviteCode(text)}
                      />
                    </>
                  )}

                {/* <CreateBookButton onClick={handleBookCreate} disabled={!bookName}>
                      {isBookCreateProcessing ? <Loader size='sm' invertColor noPadding /> : 'Create Book and Go to First Chapter'}
                  </CreateBookButton> */}
                <Button
                  sizeVariant="M"
                  variant="fillPrimary"
                  mt={18}
                  isLoading={isBookCreateProcessing}
                  width="100%"
                  onClick={checkTitleValidOrNot}
                  disabled={!bookName}
                >
                  {getModuleOrTextAccordingToLocale(
                    user,
                    contestReferrer
                      ? 'contestCreateNovelCTAText'
                      : 'createNewNovelCTAText', 
                    showSeries, 
                    tabSelected === 1
                  )}
                </Button>
              </RightDiv>
            </MainDiv>
          </Container>
        )}
      </Wrapper>
    </>
  )
}

export default withRouter(CreateNew)
